export const calculateAngle = ({
  x1,
  x2,
  y1,
  y2,
}) => {
  const dy = x2 - x1;
  const dx = y2 - y1;
  let theta = Math.atan2(dy, dx);
  theta *= 180 / Math.PI;
  return theta;
};
